export { default } from './ForecastDay';
